import {TaskStatuses} from 'src/app/current-sked/shared/task-statuses';

export interface TaskStatusInfo {
  text: string;
  color: string;
  backgroundColor?: string;
  borderColor?: string;
}

export interface TaskStatusColors {
  backgroundColor: string;
  borderColor: string;
}

/**
 * Get task status display information including text and primary color
 */
export function getTaskStatusInfo(status: TaskStatuses): TaskStatusInfo {
  switch (status) {
    case TaskStatuses.Unclaimed:
      return {
        text: 'To-do',
        color: '#CBE984',
        backgroundColor: '#DDE7F6',
        borderColor: '#5081CA',
      };
    case TaskStatuses.InProgress:
      return {
        text: 'Active',
        color: '#9CEFEF',
        backgroundColor: '#D8FFFA',
        borderColor: '#29AA9B',
      };
    case TaskStatuses.OnHold:
      return {
        text: 'On Hold',
        color: '#FFC2A1',
        backgroundColor: '#FFE1E1',
        borderColor: '#E35C49',
      };
    case TaskStatuses.Expired:
      return {
        text: 'Expired',
        color: '#E3E1FF',
        backgroundColor: '#E3E1FF',
        borderColor: '#6960CB',
      };
    case TaskStatuses.Completed:
      return {
        text: 'Done',
        color: '#E5E3DD',
        backgroundColor: '#E5E3DD',
        borderColor: '#7A746F',
      };
    case TaskStatuses.Cancelled:
      return {
        text: 'Cancelled',
        color: '#EF4444',
        backgroundColor: '#FFEAC0',
        borderColor: '#CC921F',
      };
    default:
      return {
        text: 'Unknown',
        color: '#E5E3DD',
        backgroundColor: 'var(--light)',
        borderColor: 'var(--border)',
      };
  }
}

/**
 * Get task status display text for routine items
 */
export function getTaskStatusDisplay(status: TaskStatuses): string {
  switch (status) {
    case TaskStatuses.Unclaimed:
      return 'To do';
    case TaskStatuses.InProgress:
      return 'In Progress';
    case TaskStatuses.OnHold:
      return 'On hold';
    case TaskStatuses.Expired:
      return 'Expired';
    case TaskStatuses.Completed:
      return 'Completed';
    case TaskStatuses.Cancelled:
      return 'Cancelled';
    default:
      return 'Unknown';
  }
}

/**
 * Get task status colors for background and border
 */
export function getTaskStatusColors(status: TaskStatuses): TaskStatusColors {
  const statusInfo = getTaskStatusInfo(status);
  return {
    backgroundColor: statusInfo.backgroundColor || 'var(--light)',
    borderColor: statusInfo.borderColor || 'var(--border)',
  };
}

/**
 * Get action text based on task status
 */
export function getTaskStatusAction(status: TaskStatuses): string {
  switch (status) {
    case TaskStatuses.Unclaimed:
      return 'Assigned to';
    case TaskStatuses.InProgress:
      return 'In-progress by';
    case TaskStatuses.OnHold:
      return 'On hold by';
    case TaskStatuses.Expired:
      return 'Assigned to';
    case TaskStatuses.Completed:
      return 'Completed by';
    case TaskStatuses.Cancelled:
      return 'Cancelled by';
    default:
      return 'Assigned to';
  }
}
